/**
 * ngx-spinner monkey-patch: replace detectChanges() with markForCheck()
 *
 * Why this patch exists:
 * ---------------------
 * This application uses zoneless change detection (provideZonelessChangeDetection).
 * The ngx-spinner library's `initObservable()` method calls
 * `this.changeDetector.detectChanges()` on every spinner show/hide event.
 * In zoneless mode, calling detectChanges() from within a subscription callback
 * triggers a full synchronous change-detection cycle through the entire component
 * tree, which can cause NG0100 (ExpressionChangedAfterItHasBeenChecked) cascades
 * when other components have pending signal updates.
 *
 * The fix: replace detectChanges() with markForCheck(), which simply marks
 * the component's view as dirty and lets the framework schedule a CD cycle
 * at the appropriate time — avoiding the synchronous cascade.
 *
 * This is a side-effect import: `import './patches/ngx-spinner-patch';`
 */

import { NgxSpinnerComponent } from 'ngx-spinner';
import { takeUntil } from 'rxjs/operators';

// Save original for diagnostics / future restoration
(NgxSpinnerComponent.prototype as any).__originalInitObservable =
  NgxSpinnerComponent.prototype.initObservable;

// Override initObservable to use markForCheck instead of detectChanges
NgxSpinnerComponent.prototype.initObservable = function (this: any): void {
  this.spinnerService
    .getSpinner(this.name)
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((spinner: any) => {
      this.setDefaultOptions();
      Object.assign(this.spinner, spinner);
      if (spinner.show) {
        this.onInputChange();
      }
      this.changeDetector.markForCheck();
    });
};
